const pageNameKey = "addUserDrawerModal";

export const addUserDrawerModalEn = {
  [pageNameKey]: {
    addUserTitle: "Add New User",
    userNameLabel: "User name",
    userNamePlaceholder: "Enter user name",
    givenNameLabel: "Given Name",
    givenNamePlaceholder: "Enter given name",
    familyNameLabel: "Family name",
    familyNamePlaceholder: "Enter family name",
    emailLabel: "E-mail",
    emailPlaceholder: "Enter e-mail",
    createUserButton: "Create user",
    cancelButton: "Cancel",
    rolesWarningText: "Please assign at least one role to the user.",
    inputsCheckWarningText: "Please fix the following fields:",
    userCreatedSuccessText: "User created successfully",
    userCreatedErrorText: "Error creating user",
  },
};

export const addUserDrawerModalPtBr = {
  [pageNameKey]: {
    addUserTitle: "Adicionar novo usuário",
    userNameLabel: "Nome de usuário",
    userNamePlaceholder: "Digite o nome de usuário",
    givenNameLabel: "Nome",
    givenNamePlaceholder: "Digite o nome",
    familyNameLabel: "Sobrenome",
    familyNamePlaceholder: "Digite o sobrenome",
    emailLabel: "E-mail",
    emailPlaceholder: "Digite o e-mail",
    createUserButton: "Criar usuário",
    cancelButton: "Cancelar",
    rolesWarningText: "Atribua pelo menos uma função ao usuário.",
    inputsCheckWarningText: "Corrija os seguintes campos:",
    userCreatedSuccessText: "Usuário criado com sucesso",
    userCreatedErrorText: "Erro ao criar usuário",
  },
};

export const addUserDrawerModalDe = {
  [pageNameKey]: {
    addUserTitle: "Neuen Benutzer hinzufügen",
    userNameLabel: "Benutzername",
    userNamePlaceholder: "Benutzernamen eingeben",
    givenNameLabel: "Vorname",
    givenNamePlaceholder: "Vornamen eingeben",
    familyNameLabel: "Nachname",
    familyNamePlaceholder: "Nachnamen eingeben",
    emailLabel: "E-Mail",
    emailPlaceholder: "E-Mail eingeben",
    createUserButton: "Benutzer erstellen",
    cancelButton: "Abbrechen",
    rolesWarningText: "Bitte weisen Sie dem Benutzer mindestens eine Rolle zu.",
    inputsCheckWarningText: "Bitte beheben Sie die folgenden Felder:",
    userCreatedSuccessText: "Benutzer erfolgreich erstellt",
    userCreatedErrorText: "Fehler beim Erstellen des Benutzers",
  },
};

export const addUserDrawerModalZhHans = {
  [pageNameKey]: {
    addUserTitle: "添加新用户",
    userNameLabel: "用户名",
    userNamePlaceholder: "输入用户名",
    givenNameLabel: "名字",
    givenNamePlaceholder: "输入名字",
    familyNameLabel: "姓氏",
    familyNamePlaceholder: "输入姓氏",
    emailLabel: "电子邮件",
    emailPlaceholder: "输入电子邮件",
    createUserButton: "创建用户",
    cancelButton: "取消",
    rolesWarningText: "请至少为用户分配一个角色。",
    inputsCheckWarningText: "请修复以下字段:",
    userCreatedSuccessText: "用户创建成功",
    userCreatedErrorText: "创建用户时出错",
  },
};

export const addUserDrawerModalIt = {
  [pageNameKey]: {
    addUserTitle: "Aggiungi nuovo utente",
    userNameLabel: "Nome utente",
    userNamePlaceholder: "Inserisci il nome utente",
    givenNameLabel: "Nome",
    givenNamePlaceholder: "Inserisci il nome",
    familyNameLabel: "Cognome",
    familyNamePlaceholder: "Inserisci il cognome",
    emailLabel: "E-mail",
    emailPlaceholder: "Inserisci l'e-mail",
    createUserButton: "Crea utente",
    cancelButton: "Annulla",
    rolesWarningText: "Assegna almeno un ruolo all'utente.",
    inputsCheckWarningText: "Correggi i seguenti campi:",
    userCreatedSuccessText: "Utente creato con successo",
    userCreatedErrorText: "Errore durante la creazione dell'utente",
  },
};

export const addUserDrawerModalEs = {
  [pageNameKey]: {
    addUserTitle: "Agregar nuevo usuario",
    userNameLabel: "Nombre de usuario",
    userNamePlaceholder: "Ingrese el nombre de usuario",
    givenNameLabel: "Nombre",
    givenNamePlaceholder: "Introduzca el nombre",
    familyNameLabel: "Apellido",
    familyNamePlaceholder: "Introduce el apellido",
    emailLabel: "Correo electrónico",
    emailPlaceholder: "Introduce el correo electrónico",
    createUserButton: "Crear usuario",
    cancelButton: "Cancelar",
    rolesWarningText: "Asigna al menos un rol al usuario.",
    inputsCheckWarningText: "Corrige los siguientes campos:",
    userCreatedSuccessText: "Usuario creado correctamente",
    userCreatedErrorText: "Error al crear el usuario",
  },
};

export const addUserDrawerModalNl = {
  [pageNameKey]: {
    addUserTitle: "Nieuwe gebruiker toevoegen",
    cancelButton: "Annuleren",
    createUserButton: "Gebruiker aanmaken",
    emailLabel: "E-mailadres",
    emailPlaceholder: "E-mailadres invoeren",
    familyNameLabel: "Achternaam",
    familyNamePlaceholder: "Achternaam invoeren",
    givenNameLabel: "Voornaam",
    givenNamePlaceholder: "Voornaam invoeren",
    inputsCheckWarningText: "Corrigeer de volgende velden:",
    rolesWarningText: "Wijs de gebruiker minimaal één rol toe.",
    userCreatedErrorText: "Fout bij het aanmaken van gebruiker",
    userCreatedSuccessText: "Gebruiker succesvol aangemaakt",
    userNameLabel: "Gebruikersnaam",
    userNamePlaceholder: "Gebruikersnaam invoeren",
  },
};

export const addUserDrawerModalTr = {
  [pageNameKey]: {
    addUserTitle: "Yeni Kullanıcı Ekle",
    cancelButton: "İptal etmek",
    createUserButton: "Kullanıcı oluştur",
    emailLabel: "E-posta",
    emailPlaceholder: "E-posta girin",
    familyNameLabel: "Aile adı",
    familyNamePlaceholder: "Aile adını girin",
    givenNameLabel: "İsim",
    givenNamePlaceholder: "Verilen adı girin",
    inputsCheckWarningText: "Lütfen aşağıdaki alanları düzeltin:",
    rolesWarningText: "Lütfen kullanıcıya en az bir rol atayın.",
    userCreatedErrorText: "Kullanıcı oluşturulurken hata oluştu",
    userCreatedSuccessText: "Kullanıcı başarıyla oluşturuldu",
    userNameLabel: "Kullanıcı adı",
    userNamePlaceholder: "Kullanıcı adını girin",
  },
};
